import { useMemo } from 'react'

import { useBookkeepingBankAccounts } from '@features/accounts/hooks/useBookkeepingBankAccounts'
import { SortProperty } from '@modules-deprecated/bankReconciliation/enums/sortProperty'
import { useMultipleBankLines } from '@modules-deprecated/bankReconciliation/hooks/useMultipleBankLines'
import { BankLinesQueryParams } from '@modules-deprecated/bankReconciliation/query-api'
import { ReceiptState } from '@modules-deprecated/bankReconciliation/types'

import { SortDirection } from '../../../enums/sortDirection'

export const getMissingReceiptsQueryParams = (accountId: string): BankLinesQueryParams => ({
  accountId,
  sortDirection: SortDirection.Desc,
  sortProperty: SortProperty.EntryDate,
  receiptState: ReceiptState.MissingReceipt,
  isReconciled: false,
})

export const useMissingReceiptsBankLines = (isEnabled = true) => {
  const { bookkeepingBankAccounts, isLoading: isLoadingBookkeepingBankAccounts } = useBookkeepingBankAccounts()
  const bookkeepingBankAccountsIds = useMemo(
    () => bookkeepingBankAccounts.reduce((ids: string[], { id }) => (id ? [...ids, id] : ids), []),
    [bookkeepingBankAccounts],
  )

  const queryParamsList = useMemo(
    () => bookkeepingBankAccountsIds.map(getMissingReceiptsQueryParams),
    [bookkeepingBankAccountsIds],
  )

  const {
    bankLines,
    isLoading: isLoadingBankLines,
    isError,
    errors,
  } = useMultipleBankLines(queryParamsList, isEnabled && !!queryParamsList.length)

  return {
    bankLines,
    isLoading: isLoadingBankLines || isLoadingBookkeepingBankAccounts,
    isError,
    errors,
  }
}
